<template>
  <MainPageLayout>
    <v-container class="fill-height py-10" fluid >
      <v-row align="center" justify="center">
          <v-img 
            max-width = "500px"
            contain 
            :aspect-ratio="16/9" 
            src="@/assets/logo_panel.png" alt="logo">
          </v-img>
      </v-row>
    </v-container>
  </MainPageLayout>
</template>

<script>
import MainPageLayout from "@/layouts/MainPageLayout";

export default {
  components: {
    MainPageLayout
  }
};
</script>
